<template>
    <div>
      <!-- modal -->
      <b-modal
        id="nationalTrademarkSearchOwnerFormModal"
        centered
        size="lg"
        no-close-on-backdrop
        ref="nationalTrademarkSearchOwnerFormModal"
        :title=" $t('nationalTrademarkSearchOwner.info')"
        :cancel-title=" $t('others.cancel_title')"
        :ok-title=" $t('others.ok_title')"
        cancel-variant="outline-secondary"
        @ok.prevent="addOrUpdate"
      >
      <validation-observer ref="infoRules" tag="form">
        <b-row>
          <b-col>
                  <b-form>
                    <validation-provider
                      :name=" $t('nationalTrademarkSearchOwner.name')"
                      #default="{ errors }"
                      rules="required"
                    >
                    <b-form-group
                      :label=" $t('nationalTrademarkSearchOwner.name')"
                      label-for="nationalTrademarkSearchOwner"
                      :state="errors.length > 0 ? false:null"
                    >
                        <v-select 
                        id="nationalTrademarkSearchOwner"
                        v-model="ownerSelect"
                        :options="ownerOption" 
                        label="name" 
                        @search="onSearch">
                        </v-select>
                          <b-form-invalid-feedback :state="errors.length > 0 ? false:null">
                            {{ errors[0] }}
                          </b-form-invalid-feedback> 
                    </b-form-group>
                    </validation-provider>
                  </b-form>
          </b-col>
        </b-row>
      </validation-observer>
      </b-modal>
    </div>
  </template>
  <script>

  export default {
    props: {
      nationalTrademarkSearchId: Number, 
      getNationalTrademarkSearchOwnerList: {type: Function},
      getNationalTrademarkSearchList: {type: Function},
    },
    data() {
      return {
        id: 0,
        ownerSelect: '',
        ownerOption: [],
      }
    },
    methods: {
      showInfo(){
        this.$refs['nationalTrademarkSearchOwnerFormModal'].show()
      },
      onSearch(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search(loading, search, vm) {
      if(search.length > 2){
        const data = {name: search}
        const controller = { name: 'Client', actionName:'GetOwnerClientByName' }
        const payload = {data: data, controller: controller}
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
          this.ownerOption = response.data.clientList
          loading(false)
        })
    }
    },
      addOrUpdate() {
        const data = {id: this.id, nationalTrademarkSearchId: this.nationalTrademarkSearchId, clientId: this.ownerSelect.id}
        const controller = { name: 'NationalTrademarkSearchOwner' }
        const payload = { data: data, controller: controller }
        this.$refs.infoRules.validate().then(success => {
          if (success) {
                this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                  if(response.data.resultStatus == true){
                    this.$bvModal.hide('nationalTrademarkSearchOwnerFormModal')
                    this.getNationalTrademarkSearchOwnerList()
                    this.getNationalTrademarkSearchList()
                    this.ownerSelect = ''
                    this.$SaveAlert()
                  } else {
                    this.$WarningAlert(response.data.resultMessage)
                  }
              })
              }
            })
          }
      },
  }
  </script>
  <style lang="scss">
  [dir=ltr] .modal-header .close {
      margin: -0.4rem -0.4rem -0.8rem auto;
  }
  [dir] label {
      margin-bottom: 0.2857rem;
      font-weight: bold;
  }
  .modal .modal-content {
      overflow: visible;
      margin-bottom: auto;
  }
  [dir] .invalid-tooltip {
      padding: 0.4rem 0.775rem!important;
      margin-top: -1.5rem!important;
      background-color: #ea5455!important;
      border-radius: 0.358rem!important;
      left: 20px!important
  }
  [dir] .vs__selected-options {
    padding: 0 2px;
    font-size: 0.9em;
}
.agentInput {
  max-width: 87em !important;
  width: 86em !important;
}

.custom-v-select .vs__selected,
.custom-v-select .vs__dropdown-option {
  white-space: pre-wrap !important;
}
  </style>
  